import {ChangeDetectionStrategy, Component, computed, inject, input, OnInit} from '@angular/core';
import {SearchWidgetThemeEnum} from '../../../../../../components/search-widget-v2/enums/search-widget-theme.enum';
import {SearchService} from '../../../../../../services/search/search.service';
import {SearchWidgetDataItem} from '../../../../../../types/SearchWidgetDataItem';
import {EventActionEnum, EventCategoryEnum} from '../../../../../../enums/GaTrackingEnums';
import {SearchWidgetManagerService} from '../../../../../../services/search-widget/search-widget-manager.service';
import {GtmEventEnum} from '../../../../../../enums/GoogleEnums';
import {SearchWidgetLabelsEnum} from 'src/app/components/search-widget-v2/enums/search-widget-labels.enum';
import {UrlBuilderService} from '../../../../../../services/url-builder.service';
import {DefaultValuesService} from '../../../../../../services/default-values.service';
import {SearchState} from '../../../../../../types/SearchState';
import {ToolsService} from '../../../../../../services/tools.service';
import {RoutesEnums} from '../../../../../../enums/RoutesEnums';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {CssPositionEnum} from '../../../../../../enums/CssPositionEnum';

@Component({
  selector: 'app-search-content-places',
  templateUrl: './search-content-places.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SearchContentPlacesComponent implements OnInit {
  public mainCareProviderTypeId = input<number>();
  public inferredCareProviderTypeAreaId = input<number>();
  public inferredCategoryTypeId = input<number>();
  public searchForLabel = input<string>();
  public symptomUrlPath = input<string>();
  public careServiceTypeUrlPath = input<string>();
  public pageType = input<DLPageTypeEnum>();

  protected readonly SearchWidgetThemeEnum = SearchWidgetThemeEnum;
  protected readonly SearchWidgetLabelsEnum = SearchWidgetLabelsEnum;
  protected readonly cssPositionEnum = CssPositionEnum;
  protected readonly EventActionEnum = EventActionEnum;
  protected readonly EventCategoryEnum = EventCategoryEnum;
  protected readonly DLPageTypeEnum = DLPageTypeEnum;
  private searchService = inject(SearchService);
  public isLocationLoading = this.searchService.isLocationLoading;
  private places = this.searchService.places;
  public popularPlaces = computed(() => this.getUpdatedPopularPlaces(this.places()?.popularPlaces));

  constructor(
    private searchWidgetManagerService: SearchWidgetManagerService,
    private urlBuilder: UrlBuilderService,
    private defaults: DefaultValuesService,
    private tools: ToolsService,
  ) {}

  public ngOnInit(): void {
    this.searchService.reloadPlaces();
  }

  protected searchByLocationClick(): void {
    this.searchWidgetManagerService.registerGtmGa4Event(
      `${EventCategoryEnum.SEARCHNAV} - search by location click`,
      GtmEventEnum.CTA_CLICK,
      this.pageType(),
      this.mainCareProviderTypeId(),
      this.inferredCareProviderTypeAreaId(),
      this.inferredCategoryTypeId(),
    );
    this.searchService.isLocationLoading.set(true);
    this.searchWidgetManagerService.getUserLocation(null, true, false, true);
  }

  private getUpdatedPopularPlaces(places: SearchWidgetDataItem[]): SearchWidgetDataItem[] {
    if (!places) {
      return [];
    }
    const state: SearchState = this.tools.clone(this.defaults.getDefaultSearchState());
    if (this.symptomUrlPath()) {
      state.symptomUrlPath = this.symptomUrlPath();
    }
    if (this.careServiceTypeUrlPath()) {
      state.careServiceTypeUrlPath = this.careServiceTypeUrlPath();
    }
    places.forEach((place) => {
      state.placeUrlPath = place.urlPath;
      place.routerLink = this.urlBuilder.CreateSearchResultsRouterLink(state, ['/', RoutesEnums.SEARCH], false);
    });
    return places;
  }
}
